module.exports = __webpack_public_path__ + "img/homemade-pizza-dough.8269cfb4.jpg";